const BUSINESS_SCRIPT_URL =
  'https://namesapi.njjamaat.org/business-data';

const CACHE_KEY = 'businessListingsData';

let businessListingsPromise = null;
let businessListingsCache = null;

export function prefetchBusinessListingsData() {
  console.log('prefetchBusinessListingsData called');

  if (businessListingsCache) {
    console.log('Using in-memory business listings cache');
    return Promise.resolve(businessListingsCache);
  }

  const savedData = sessionStorage.getItem(CACHE_KEY);

  if (savedData) {
    console.log('Using sessionStorage business listings cache');

    try {
      businessListingsCache = JSON.parse(savedData);
      return Promise.resolve(businessListingsCache);
    } catch {
      sessionStorage.removeItem(CACHE_KEY);
    }
  }

  if (businessListingsPromise) {
    console.log('Business listings fetch already in progress');
    return businessListingsPromise;
  }

  console.log('Fetching business listings from API');

  businessListingsPromise = fetch(BUSINESS_SCRIPT_URL)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to fetch business listings');
      }

      return response.json();
    })
    .then((data) => {
      const businesses = data.businesses || {};

      businessListingsCache = businesses;
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(businesses));

      return businesses;
    })
    .catch((error) => {
      console.error('Business listings fetch failed:', error);
      businessListingsPromise = null;
      throw error;
    });

  return businessListingsPromise;
}

export function getBusinessListingsData() {
  return prefetchBusinessListingsData();
}